// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wV6N0","requiredAsterisk":"Info_requiredAsterisk__3IHWF"};